import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PPUPackageImageModel } from '@app/shared/models/deliver-customer.model';
@Component({
  selector: 'app-package-image-popup',
  templateUrl: './package-image-popup.component.html',
  standalone: false,
})
export class PackageImagePopupComponent{
  constructor(
    private dialogRef: MatDialogRef<PackageImagePopupComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      packageImages: PPUPackageImageModel[];
    }
  ) {
    this.dialogRef.updateSize('490px', 'auto');
  }

  close(): void {
    this.dialogRef.close();
  }
}
